import React from 'react'
import PropTypes from 'prop-types'
import ErrorDisplay from '../ErrorDisplay'
import './AccountManagementForm.css'
import 'font-awesome/css/font-awesome.css'
import StripeCardForm from '../StripeCardForm'

const AccountManagementForm = (props) => {

    return (
        <StripeCardForm disabled={props.disabled}/>
    )
}


AccountManagementForm.propTypes = {
    disabled: PropTypes.bool.isRequired
}

export default AccountManagementForm





// WEBPACK FOOTER //
// ./src/components/AccountManagementForm/AccountManagementForm.js